import React from "react";

import { BaseComponent } from "shared/components";

/**
 *
 * @param choices list of choices
 * @param choicesStream should be a promise
 */
function withBaseButtonSelect(choices, choicesStream = undefined, noReset = false) {
    return class extends BaseComponent {
        constructor(props) {
            super(props);

            this.defaultValue = props.value ? props.value : "";
            this.label = props.label ? props.label : "";

            this.state = {
                value: this.defaultValue,
                values: choices,
                noReset: noReset
            };

            this.onChange = this.onChange.bind(this);
            this.resetState = this.resetState.bind(this);
        }

        async componentDidMount() {
            if (choicesStream) {
                await choicesStream((values) => {
                    this.setState({ values });
                });
            }

            const value = this.state.values.find((v) => v.value === this.props.value)?.value;
            this.setState({ value });
        }

        componentDidUpdate(prevProps) {
            const { values } = this.state;
            if (this.props.value !== prevProps.value) {

                // find value by value
                const value = values.find((v) => v.value === this.props.value)?.value;
                this.setState({ value });
            }
        }

        onChange(value) {
            this.setState({ value: value });

            if (this.props.onChange) {
                const name = this.props.name;
                this.props.onChange({
                    target: { name, value }
                });
            }
        }

        resetState() {
            if (!this.state.noReset) {
                this.setState({ value: "" });
            }
        }

        render() {
            const { value, values } = this.state;
            const { className } = this.props;

            const columnSize = values.length === 4 ? 'is-6' : 'is-4';

            return (
                <>
                    <label className="label">{this.label}</label>
                    <div className="columns is-multiline">
                        {values?.map(v =>
                            <div className={`column ${columnSize}`} key={v.label}>
                                <button
                                    type="button"
                                    className={`button ${className} is-fullwidth ${v.label === value ? "is-link" : ""}`}
                                    onClick={() => this.onChange(v.value)}>{v.label}
                                </button>
                            </div>
                        )}
                    </div>
                </>
            );
        }
    }
}

export default withBaseButtonSelect;
